export default __webpack_public_path__ + "static/media/2.8f54cc17.jpg";